export const countingCharacters = function (input) {
  const characterCounter = document.createElement('div');
  characterCounter.classList.add('character-counter');
  characterCounter.innerText = `0 / ${input.getAttribute('maxlength')}`;
  input.closest('fieldset').append(characterCounter);
  input.addEventListener('input', function () {
    characterCounter.innerText = `${this.value.length} / ${this.getAttribute('maxlength')}`;
  });
};
